import { Check } from "lucide-react";
import { PROCEDURE_STEPS } from "@/lib/crmHelpers";

export default function ProcedureChecklist({ procedure = {}, onToggle, readOnly = false }) {
  const done = PROCEDURE_STEPS.filter((s) => procedure[s.key]).length;
  const pct = Math.round((done / PROCEDURE_STEPS.length) * 100);

  return (
    <div data-testid="procedure-checklist" className="space-y-3">
      <div className="flex items-center justify-between">
        <div className="text-label text-muted-foreground">Procédure standard</div>
        <div className="text-xs font-medium text-muted-foreground">
          <span className="font-heading font-semibold text-foreground">{done}</span> / {PROCEDURE_STEPS.length}
        </div>
      </div>

      <div className="h-1 w-full overflow-hidden rounded-full bg-muted">
        <div
          className="h-full rounded-full bg-emerald-500 transition-all duration-300"
          style={{ width: `${pct}%` }}
        />
      </div>

      <div className="grid gap-1.5 sm:grid-cols-2">
        {PROCEDURE_STEPS.map((s, i) => {
          const checked = !!procedure[s.key];
          return (
            <button
              key={s.key}
              type="button"
              disabled={readOnly}
              onClick={() => onToggle?.(s.key, !checked)}
              data-testid={`procedure-${s.key}`}
              className={`group flex items-center gap-2 rounded-md border px-2.5 py-2 text-left text-sm transition-all ${
                checked
                  ? "border-emerald-200 bg-emerald-50 text-emerald-900 dark:border-emerald-900/40 dark:bg-emerald-950/30 dark:text-emerald-200"
                  : "border-border/60 bg-card hover:border-foreground/20"
              } ${readOnly ? "cursor-default" : "cursor-pointer"}`}
            >
              <span
                className={`flex h-5 w-5 flex-none items-center justify-center rounded border transition-colors ${
                  checked
                    ? "border-emerald-500 bg-emerald-500 text-white"
                    : "border-border bg-background"
                }`}
              >
                {checked && <Check className="h-3 w-3" strokeWidth={3} />}
              </span>
              <span className="truncate">
                <span className="mr-1 text-xs text-muted-foreground">{i + 1}.</span>
                {s.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
